function search(phrase, callable, failCallback) {

    function getWordSpace(word) {
        return $.md5(word).substr(0, 2);
    }

    function prepearPhrase(phrase) {
        console.log(phrase);
        var words = [];
        var regex = /[\wąćęłńóśżźĄĆĘŁŃÓŚŻŹ]{3,}/uig;
        var word;
        while (word = regex.exec(phrase)) {
            words.push(word[0]);
        }
        console.log(words);
        return words;
    }

    function getSpace(space) {
        $.ajax({
            url: '/raportcsr2018/dist/search/' + space + '.json',
            dataType: 'json',
            timeout: 5000
        }).fail(function () {
            spaceBody[space] = [];
        }).done(function (data) {
            spaceBody[space] = data;
        }).always(function () {
            if (--spacesRemain <= 0) {
                spacesLoaded();
            }
        });
    }

    function getResults(pageIndexes, callback, failCallback) {
        $.ajax({
            url: '/raportcsr2018/dist/search/index.json',
            dataType: 'json',
            timeout: 5000
        }).fail(function () {
            failCallback();
        }).done(function (pages) {
            var result = [];
            var sortedKeys = Object.keys(pageIndexes).sort(function(a,b){
                return pageIndexes[b]-pageIndexes[a]
            });
            sortedKeys.forEach(function (id) {
                if (pages[id] !== undefined) {
                    result.push(pages[id]);
                }
            });
            callback(result);
        });
    }

    var words = prepearPhrase(phrase);
    var wordMap = [];
    words.forEach(function (word) {
        var space = getWordSpace(word);
        if (wordMap[space] == undefined) {
            wordMap[space] = [];
        }
        wordMap[space].push(word);
    });

    var spaces = Object.keys(wordMap);
    var spaceBody = [];
    var spacesRemain = spaces.length;
    spaces.forEach(function (space) {
        getSpace(space);
    });

    function spacesLoaded() {
        var pageIndexes = [];
        spaces.forEach(function (space) {
            wordMap[space].forEach(function (word) {
                if (spaceBody[space][word] !== undefined) {
                    addIndexes(pageIndexes, spaceBody[space][word]);
                }
            });
        });
        getResults(pageIndexes, callable, failCallback);
    }
    
    function addIndexes(pageIndexes, space) {
        Object.keys(space).forEach(function (index) {
            if (pageIndexes[index] === undefined) {
                pageIndexes[index] = space[index];
            } else {
                pageIndexes[index] += space[index];
            }
        });
    }
}

$('.submenu__search input').on("change paste keyup", function() {
  $('.submenu__search a').attr('href','/raportcsr2018/pl/search.html#'+$(this).val());

});

$('.submenu__search a').on('click', function() {
  const href =  $('.submenu__search a').attr('href');
  location.href = href;
  checkUrl();
});

function checkUrl() {
  const href = window.location.href;
  const phrase = decodeURI(window.location.hash.substr(1));
  if(href.indexOf('search.html') > -1) {
    const searchText = phrase;
    search(searchText, function(results){
      if(results.length > 0) {
        let li = ''
        for(let i = 0; i < results.length; i++) {
          li += '<li><a href="'+results[i].url+'">' + results[i].title + '</a></li>';
        }
        $('.search-content').html('<ul>'+ li +'</ul>');
      } else {
        $('.search-content').html('<p>Brak wyników</p>');
      }
    }, function(){
      console.log('błąd');
    });
  }
}
checkUrl();
$('#submenuSearch').on('keypress',function(event){
    if(event.originalEvent.keyCode==13){
        $('.submenu__search a').trigger('click');
    }
});